import React from 'react'
import { Avvia_Partita } from '../../Components'
const Avvia_Partita4 = () => {
    return (
        <div>
            <Avvia_Partita no={1}/>
        </div>
    )
}

export default Avvia_Partita4
